import { AnyDocument, Entity } from '../types';

export const getDocumentTargetAndLocationForPath = (
  rootDocument: AnyDocument | undefined,
  documentPath: string[],
): [AnyDocument | AnyDocument[] | undefined, string] => {
  const buildPath = (prevPath: string, subPath: string): string =>
    `${prevPath ? `${prevPath}.` : ''}${subPath}`;

  return documentPath.reduce<[AnyDocument | undefined, string]>(
    ([object, path], docSubPath) => {
      if (!object) return [undefined, path];

      if (docSubPath.includes('.')) {
        const [attr, id] = docSubPath.split('.');
        const array = (object as Entity)[attr] as AnyDocument[];
        if (Array.isArray(array)) {
          const idx = array.findIndex((v) => v.id === id);
          if (idx === -1) return [undefined, buildPath(path, attr)];
          return [array[idx], buildPath(path, `${attr}[${idx}]`)];
        }
        return [array, buildPath(path, `${attr}`)];
      }
      return [
        (object as Entity)[docSubPath] as AnyDocument,
        buildPath(path, docSubPath),
      ];
    },
    [rootDocument, ''],
  );
};
